import { PhoneOption } from 'src/app/pages/phones/models/phone-option.interface';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const phoneOptionActions = createEagerSelectActions<PhoneOption>('[Phone Options]');
